import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import React, { Component } from 'react';
import { Menu, Badge } from 'antd';
import { withTranslation } from 'react-i18next';
var styles = {
  Titles: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#333333'
  }
};

var Alerts = /*#__PURE__*/function (_Component) {
  _inherits(Alerts, _Component);

  var _super = _createSuper(Alerts);

  function Alerts() {
    _classCallCheck(this, Alerts);

    return _super.apply(this, arguments);
  }

  _createClass(Alerts, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/React.createElement("div", {
        className: "Alerts"
      }, /*#__PURE__*/React.createElement(Menu, {
        className: "AlertBox"
      }, /*#__PURE__*/React.createElement(Menu.Item, {
        key: "1",
        className: "Data"
      }, /*#__PURE__*/React.createElement(Badge, {
        color: "red",
        text: /*#__PURE__*/React.createElement("span", {
          style: styles.Titles
        }, t('components_shared_Alerts.titles.0'))
      })), /*#__PURE__*/React.createElement(Menu.Item, {
        key: "2",
        className: "Data"
      }, /*#__PURE__*/React.createElement("p", null, 'Alerta 1: Tiene un aviso pendiente de revisar')), /*#__PURE__*/React.createElement(Menu.Item, {
        key: "3",
        className: "Data"
      }, /*#__PURE__*/React.createElement("p", null, 'Alerta 2: Tiene un email pendiente')), /*#__PURE__*/React.createElement(Menu.Divider, null), /*#__PURE__*/React.createElement(Menu.Item, {
        key: "4",
        className: "Data"
      }, /*#__PURE__*/React.createElement(Badge, {
        color: "#FFCD00",
        text: /*#__PURE__*/React.createElement("span", {
          style: styles.Titles
        }, t('components_shared_Alerts.titles.1'))
      })), /*#__PURE__*/React.createElement(Menu.Item, {
        key: "5",
        className: "Data"
      }, /*#__PURE__*/React.createElement("p", null, 'Alerta 1: Tiene un aviso pendiente'))));
    }
  }]);

  return Alerts;
}(Component);

export default withTranslation()(Alerts);